'use strict';

angular.module('projectsManagement')
  .controller('NotesListCtrl', [
    '$scope', 'notesListViewModel', 'masterId',
    function (scope, viewModel, masterId) {
      scope.vm = new viewModel(masterId);
    }
  ]);